function arrondir (value, decimals) {
    return Number((value).toFixed(decimals))
}

export default arrondir